<!--
用select来实现选择器（主要服务IE）

使用说明：

<SimplePicker
    :columns="[{className: '', values:[]}]"
    title="选择城市" 
    @cancel="onCancel" 
    @confirm="onConfirm" 
    @change="onChange" 
    value-key="name"
 />

-->

<template>
    <div class="simple-picker-wrap">
        <div class="actions">
            <a href="javascript:;" class="left" @click="onCancel">取消</a>
            <span>{{title}}</span>
            <a href="javascript:;" class="right" @click="onConfirm">确定</a>
        </div>
        <div class="selector-wrap">
            <select  v-for="(c,i) in columns" :ref="'s-'+i" :key="c.className" v-if="c.values.length > 0" @change="onChange(c,i, $event)" :class="c.className">
                <option :value="v[valueKey]" v-for="v in c.values" :key="v[valueKey]">{{v.toString()}}</option>
            </select>
        </div>
        
    </div>
</template>

<script>
export default {
  props: ['columns','title','value-key'],
  data () {
      
      return {
          init: true,
          vals: []
      }
  },
  watch: {
  },
  methods: {
      getValues(){
          return this.vals;
      },
      setColumnValues(index, values){
          for(var i = index; i < this.columns.length; i++){
              this.columns[i].values = [];
          }
          this.columns[index].values = values;
          for(var i = index; i < this.vals.length; i++){
              this.vals[i] = null;
          }
          this.vals[index] = values[0];
      },
      getColumnValue(index){
          console.log('getColumnValue:'+index);
          if(this.init){
              //将逐项赋值
              for(var i=0; i<this.columns.length;i ++){
                if(!this.vals[i]){
                    var c = this.columns[i];
                    if(c.values.length > 0){
                        this.vals.push(c.values[0]);
                    }else{
                        this.vals.push(null);
                    }
                }
                
              }
          }
          return this.vals[index];
      },
      onCancel(){
          this.$emit('cancel');
      },
      onConfirm(){
          this.$emit('confirm');
      },
      onChange(cols, index, $event){
        var v;
        for(var i = 0; i < cols.values.length; i++){
            var c = cols.values[i];
            if(c[this.valueKey] == $event.target.value){
                v = c;
                break;
            }
        }

        this.vals[index] = v;
        console.log(v);
        

        this.$emit('change', 
            this, this.vals, index
        );
      }
  }
}
</script>

<style lang="less" scoped>

.simple-picker-wrap{

    .actions{
        height: 44px;
        line-height: 44px;
        position: relative;

        @gap : (44px - 16px)/2;

        a{
            color: #38f;
            text-decoration: none;
        }

        .left{
            position: absolute;
            top: 0;
            left: @gap;
        }

        .right{
            position: absolute;
            top: 0;
            right: @gap;
        }

        span{
            display: block;
            font-size: 16px;
            font-weight: 500;
            text-align: center;
        }
    }

    .selector-wrap{

        padding: 20px;
        select{
            display: inline-block;
            margin-right: 8px;
            font-size: 20px;
            width: 20%;
        }   
    }


}

</style>





// WEBPACK FOOTER //
// src/components/common/SimplePicker.vue